import cmp from '../../lib/cmp';
import './sm-landing-appstore-app-1-ios-panel.less';


import imageToday from '../../images/landing-appstore/today';
import imageGames from '../../images/landing-appstore/games';
import imageApps from '../../images/landing-appstore/apps';
import imageUpdates from '../../images/landing-appstore/updates';
import imageSearch from '../../images/landing-appstore/search';



const rowItem = (text, icon, isPrimary = false) => `
  <div class="sm-landing-appstore-app-1-ios-panel__item">
    <div class="sm-landing-appstore-app-1-ios-panel__item-in">
      <div class="sm-landing-appstore-app-1-ios-panel__item-icon">${icon}</div>
      <div class="sm-landing-appstore-app-1-ios-panel__item-text-primary ${isPrimary ? 'sm-landing-appstore-app-1-ios-panel__item-text--primary' : ''}">${text}</div>
    </div>
  </div>
`;

const iosPanelView = () => `
  <div class="sm-landing-appstore-app-1-ios-panel">
    <div class="sm-landing-appstore-app-1-ios-panel__list">
      ${rowItem('Today', imageToday({ color: '#a1a1a1' }))}
      ${rowItem('Games', imageGames({ color: '#a1a1a1' }))}
      ${rowItem('Apps', imageApps({ color: '#a1a1a1' }))}
      ${rowItem('Updates', imageUpdates({ color: '#a1a1a1' }))}
      ${rowItem('Search', imageSearch({ color: '#267ff9' }), true)}
    </div>
  </div>
`;

export default cmp(null, iosPanelView);




// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-ios-panel/sm-landing-appstore-app-1-ios-panel.js